<template>
	<div :class="['yl-footer w100', className]" :style="{background:bgColor,color:fontColor}">
		<el-row class="yl-warp text-center pb6">
			Copyright © 2017中企云链 All Rights Reserved | 
			<a target="_blank" href="https://beian.miit.gov.cn/" :style="{color:fontColor}">津ICP备2023008374号-7(yljr.com)</a> | 
			<a target="_blank" href="https://beian.miit.gov.cn/" :style="{color:fontColor}">津ICP备2023008374号-14(云链.com)</a>
			<img class="footer_img_center pl16" src="../assets/images/icon_ba_wj.png" />
			<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602100249" target="_blank" :style="{color:fontColor}">京公网安备 11010602100249号</a>
		</el-row>
		<el-row class="yl-warp text-center">
			<a href="https://bcbeian.ifcert.cn/index" class="pl16" target="_blank" :style="{color:fontColor}">京网信备 11010720904245590029号</a>
			<a href="https://bcbeian.ifcert.cn/index" class="pl16" target="_blank" :style="{color:fontColor}">京网信备 11010720904245590010号</a>
			<img src="../assets/images/cert.png" class="cert pl16" @click="toBlank"/>
		</el-row>
	</div>
</template>
<script>
export default {
	props:["type","bgColor","fontColor"],
	data() {
		return {
			// 查看代码发现此处两个class应该没有地方使用了，先暂留  感觉没用 统一了footer样式
			className: {
				single: this.type=='single', 
				clearfix: this.type=='single'
			}
		}
	},
	methods:{
		toBlank() {
			window.open("https://credit.szfw.org/CX20171109036667111635.html");
		}
	},
}
</script>